var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3456 2.43179H18.5683V0.654425C18.5683 0.292988 18.2753 0 17.9139 0H0.654425C0.293024 0 0 0.292988 0 0.654425V18.904C0 19.2654 0.293024 19.5585 0.654425 19.5585H2.43183V21.3358C2.43183 21.6972 2.72485 21.9902 3.08625 21.9902H20.3456C20.7071 21.9902 21 21.6972 21 21.3358V3.08622C21.0001 2.72481 20.7072 2.43179 20.3456 2.43179ZM2.62352 9.72493C2.50074 9.84764 2.43183 10.0141 2.43183 10.1876V18.2495H1.30889V1.30889H17.2594V2.43179H10.1877C10.0141 2.43179 9.84775 2.50078 9.72501 2.62356L2.62352 9.72493ZM9.53331 4.66621V9.53327H4.66624L9.53331 4.66621ZM19.6912 20.6814H3.74071V10.8421H10.1877C10.5491 10.8421 10.8422 10.5491 10.8422 10.1877V3.74535C10.8422 3.74377 10.842 3.74222 10.842 3.74064H19.6912V20.6814Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaDefaultIcon);
export default __webpack_public_path__ + "static/media/media-default-icon.cfcc9d2018e8678041ca49bcbb656de5.svg";
export { ForwardRef as ReactComponent };